import axios from 'src/utils/axios';
import { endpoints } from 'src/utils/axios';

export const addLog = async (apiData) => {
  const URL = endpoints.logs.create;

  try {
    const { data } = await axios.post(URL, apiData);
    return data;
  } catch (error) {
    console.error('Error adding log:', error);
    throw error;
  }
};
